import { render, staticRenderFns } from "./LandPageTotals.vue?vue&type=template&id=3ceb6732&scoped=true&"
import script from "./LandPageTotals.vue?vue&type=script&lang=js&"
export * from "./LandPageTotals.vue?vue&type=script&lang=js&"
import style0 from "./LandPageTotals.vue?vue&type=style&index=0&id=3ceb6732&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ceb6732",
  null
  
)

export default component.exports